import { OptionNameValuePair } from "../../../lib/interfaces/types";

const renderDropdownOption = (name: string) => (
  <span className="rounded-lg gap-1 border opacity-100 px-2 py-0.5  bg-[#EBEEFE]  text-[#304ADD] whitespace-nowrap">
    {name}
  </span>
);

export const RECOMMENDED_ACTION_DROPDOWN_OPTIONS: OptionNameValuePair<string>[] =
  [
    {
      name: "Initiate Disciplinary Action",
      value: "Initiate Disciplinary Action",
      display_component: renderDropdownOption("Initiate Disciplinary Action"),
    },
    {
      name: "Issue Warning",
      value: "Issue Warning",
      display_component: renderDropdownOption("Issue Warning"),
    },
    {
      name: "Initiate Suspension",
      value: "Initiate Suspension",
      display_component: renderDropdownOption("Initiate Suspension"),
    },
    {
      name: "Deactivate Partner Code",
      value: "Deactivate Partner Code",
      display_component: renderDropdownOption("Deactivate Partner Code"),
    },
    {
      name: "Initiate Termination",
      value: "Initiate Termination",
      display_component: renderDropdownOption("Initiate Termination"),
    },
    {
      name: "Initiate Legal Action",
      value: "Initiate Legal Action",
      display_component: renderDropdownOption("Initiate Legal Action"),
    },
    {
      name: "Issue Show Cause Notice",
      value: "Issue Show Cause Notice",
      display_component: renderDropdownOption("Issue Show Cause Notice"),
    },
    {
      name: "Terminate Vendor Contract",
      value: "Terminate Vendor Contract",
      display_component: renderDropdownOption("Terminate Vendor Contract"),
    },
  ];
